// 活动状态
// 未达标
export const STATUS_NOT_MEET = 0;
// 已达标
export const STATUS_MEET = 1;
// 已过期
export const STATUS_EXPIRED = 2;

export const EFFORTLESS_REWARD_INDICATOR_TEXT = {
  nat: {
    type: 'nat',
    text: '将NAT类型优化至 “全锥型”及以上',
    link: 'intent:https://help.yfanqie.com/9dd6/01db',
  },
  ipv6: {
    type: 'ipv6',
    text: '打开IPv6并保证IPv6可连通',
    link: 'intent:https://help.yfanqie.com/9dd6/dfcb',
  },
};

// 每天达标状态
// 未达标
export const DAY_NOT_MEET_STATUS = 0;
// 达标
export const DAY_MEET_STATUS = 1;

export const FAIL_REASON_MAP = {
  '1': '在线时长未达标，或磁盘存在异常，请保证设备稳定在线',
  '2': '当日晚高峰贡献带宽未满足要求',
};

export const DEFAULT_BANNER_CONFIG = {
  text: '87%的用户还加机了这款产品!!!',
  link: 'youzan:https://j.youzan.com/8eJ_Pd',
};

export const DEFAULT_INDICATOR_LIST = [
  {
    type: 'nat',
    status: -1,
  },
  {
    type: 'ipv6',
    status: -1,
  },
];
